import { PlanCard } from "../PlanCard";
import type { TPlanSlider } from "./types";

export const PlanSlider = ({ allPlans }: TPlanSlider) => {
  const PlanSliderElement = document.createElement("div");
  PlanSliderElement.className = "w-full flex flex-col overflow-hidden";

  PlanSliderElement.innerHTML = /* html */ `
        <div 
            class="flex flex-1 overflow-auto divide-x border-t border-b border-gray-100 divide-gray-100 scrollbar-hide lg:grid lg:grid-cols-4" id="plan-slider"
        >
        </div>
    `;

  const slider = PlanSliderElement.querySelector("#plan-slider");

  if (slider)
    allPlans.forEach((planProps) => {
      slider.appendChild(PlanCard(planProps));
    });

  return PlanSliderElement;
};
